import * as Yup from "yup";

const yupValidationSchema = Yup.object().shape({
  requestType: Yup.string().required("The request type is required"),
  opportunityId: Yup.string().when("withCrmOpportunityId", {
    is: "Yes",
    then: Yup.string()
      .required("The Opportunity id is required")
      .matches(
        /^(crm-opp-\d{6}|CRM-OPP-\d{6}|\d{6})$/,
        "The Opportunity id is not in the correct format use CRM-OPP-XXXXXX, crm-opp-XXXXXX or XXXXXX",
      ),
  }),
});

export default yupValidationSchema;
